import type { Components } from "@mui/material/styles";

import type { Theme } from "../types";

export const MuiDialog = {
	styleOverrides: {
		paper: ({ theme }) => ({
			margin: theme.spacing(1),
			[theme.breakpoints.up("sm")]: {
				margin: theme.spacing(4),
			},
		}),
	},
} satisfies Components<Theme>["MuiDialog"];
